var cilBatteryEmpty = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M39.986,424H408a23.825,23.825,0,0,0,24-23.59V344h64V176H432V119.59A23.825,23.825,0,0,0,408,96H39.986a23.825,23.825,0,0,0-24,23.59V400.41A23.825,23.825,0,0,0,39.986,424Zm8-296H400v80h64V312H400v80H47.986Z' class='ci-primary'/>"];

export { cilBatteryEmpty };

